<template>
  <div  :style="{'width': '1880px', height: (height - 82) + 'px'}" style="margin: 0 auto">
    <div class="diagram sub-left" style="margin: 0 auto;width: 100%;position: relative">
      <div style="z-index: 998;position: absolute;left: 1rem;top: 2rem" class="table-size">
        <div class="main-table D01" style="height: 7.98rem">
          <div class="JL">
            <div class="main-table-row IA"  >
              <span class="main-table-cell" style="flex: auto">3ES环境参数（1）</span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">温度</span>
              <span class="main-table-cell" style="flex: auto" >{{sensorCompute('ES3T02', 0)}}</span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">湿度</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES3T02', 1)}}</span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">烟雾</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES3Y02', 2)}}</span>
            </div>
            <div class="main-table-row Q">
              <span class="main-table-cell">水浸</span>
              <span class="main-table-cell uc-value" style="flex: auto">{{sensorCompute('ES3S02', 3)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 12rem;top: 2rem" class="table-size">
        <div class="main-table D01" style="height: 7.98rem">
          <div class="JL">
            <div class="main-table-row IA"  >
              <span class="main-table-cell" style="flex: auto">3ES环境参数（2）</span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">温度</span>
              <span class="main-table-cell" style="flex: auto" >{{sensorCompute('ES3T01', 0)}}</span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">湿度</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES3T01', 1)}}</span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">烟雾</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES3Y01', 2)}}</span>
            </div>
            <div class="main-table-row Q">
              <span class="main-table-cell">水浸</span>
              <span class="main-table-cell uc-value" style="flex: auto">{{sensorCompute('ES3S01', 3)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="false" style="z-index: 998;position: absolute;left: 28.8rem;top: 2.0rem;" class="table-size">
        <div class="main-table D01" style="width: 9.0rem">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '45.70A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5989.7V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '450kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.95'"></span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="false" style="z-index: 998;position: absolute;left: 42.6rem;top: 2.0rem;" class="table-size">
        <div class="main-table D01" style="width: 9.0rem">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '45.70A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5989.7V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '450kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.95'"></span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="false" style="z-index: 998;position: absolute;left: 56.5rem;top: 2.0rem" class="table-size">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '21.8A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5961.1V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '216.2kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.96'"></span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="false" style="z-index: 998;position: absolute;left: 76.8rem;top: 2.0rem" class="table-size">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '4.3A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5992.1V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '43.2kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.97'"></span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="false" style="z-index: 998;position: absolute;left: 93.4rem;top: 2.0rem" class="table-size">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '4.50A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5923.6V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '44.3kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.95'"></span>
            </div>
          </div>
        </div>
      </div>


      <img src="../../assets/img/es3.svg" alt="ES2背景图" class="bg-diagram" draggable="false" style="height: auto;position: absolute;left: 0;top: 0">
      <div>
        <SignalNode node-title="D3-2AN15" type="1" info="柴发进线柜"  :context="context" node-style="position: absolute;width: 6.1rem;height: auto;left: 83rem;top: 50.8rem;background-color: transparent;"></SignalNode>

        <SignalNode node-title="J421" info="421进线隔离小车" :context="context" node-style="left: 27.46rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="3-#3变压器423开关小车" node-title="J423" node-style="left: 41.29rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="3-#2变压器422开关小车" node-title="J422" node-style="left: 55.094rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="341进线隔离小车" node-title="J341" node-style="left: 75.41rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="3-#1变压器342开关小车" node-title="J342" node-style="left: 91.97rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>

        <SignalNode :context="context" info="3-#3变压器进线柜" node-title="D3-3AN1" node-style="left: 3.7rem;top: 17.46rem;"></SignalNode>
        <SignalNode :context="context" info="动态自动无功补偿" node-title="D3-3AN2" node-style="left: 6.77rem;top: 17.46rem;"></SignalNode>
        <SignalNode :context="context" info="动态自动无功补偿" node-title="D3-3AN3" node-style="left: 9.9rem;top: 17.46rem;"></SignalNode>
        <SignalNode :context="context" info="有源滤波装置" node-title="D3-3AN4" node-style="left: 13.71rem;top: 17.46rem;"></SignalNode>

        <SignalNode :context="context" info="离心式冷水机组" node-title="D3-3AN5-1" node-style="left: 16.59rem;top: 17.46rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN5-2" node-style="left: 20.41rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN5-3" node-style="left: 22.24rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="冷冻水一级泵" node-title="D3-3AN5-4" node-style="left: 24.15rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN5-5" node-style="left: 26rem;top: 17.4rem;"></SignalNode>

        <SignalNode :context="context" info="离心式冷水机组" node-title="D3-3AN6-1" node-style="left: 27.9rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN6-2" node-style="left: 31.6rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN6-3" node-style="left: 33.47rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="冷冻水一级泵" node-title="D3-3AN6-4" node-style="left: 35.35rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN6-5" node-style="left: 37.23rem;top: 17.4rem;"></SignalNode>

        <SignalNode :context="context" info="离心式冷水机组" node-title="D3-3AN7-1" node-style="left: 39.1rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN7-2" node-style="left: 42.85rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN7-3" node-style="left: 44.73rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN7-4" node-style="left: 46.59rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-3AN7-5" node-style="left: 48.54rem;top: 17.4rem;"></SignalNode>

        <SignalNode :context="context" info="消防风机（主用）" node-title="D3-1AN14-1" node-style="left: 52.2rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源（主用）" node-title="D3-1AN14-2" node-style="left: 54.05rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="排烟风机（主用）" node-title="D3-1AN14-3" node-style="left: 55.96rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源（主用）" node-title="D3-1AN14-4" node-style="left: 57.8rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-1AN14-5" node-style="left: 59.7rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-1AN14-6" node-style="left: 61.54rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-1AN14-7" node-style="left: 63.41rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-1AN14-8" node-style="left: 65.29rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-1AN14-9" node-style="left: 67.16rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN14-10" node-style="left: 69.04rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN14-11" node-style="left: 70.95rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN14-12" node-style="left: 72.79rem;top: 17.4rem;"></SignalNode>

        <SignalNode :context="context" info="备用" node-title="D3-1AN13-1" node-style="left: 74.66rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-1AN13-2" node-style="left: 76.54rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-1AN13-3" node-style="left: 78.4rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-1AN13-4" node-style="left: 80.29rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-1AN13-5" node-style="left: 82.13rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-1AN13-6" node-style="left: 84.0rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-1AN13-7" node-style="left: 85.91rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-1AN13-8" node-style="left: 87.78rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN13-9" node-style="left: 89.66rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN13-10" node-style="left: 91.5rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN13-11" node-style="left: 93.35rem;top: 17.4rem;"></SignalNode>

        <SignalNode :context="context" info="屋顶融雪电伴热" node-title="D3-1AN12-1" node-style="left: 95.23rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-1AN12-2" node-style="left: 97.1rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="防火分区F02-1-F02-2-5普通风机" node-title="D3-1AN12-3" node-style="left: 98.98rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-1AN12-4" node-style="left: 100.9rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN12-5" node-style="left: 102.7rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN12-6" node-style="left: 104.6rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN12-7" node-style="left: 106.47rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN12-8" node-style="left: 108.35rem;top: 17.4rem;"></SignalNode>

        <SignalNode :context="context" info="厨房" node-title="D3-1AN11-1" node-style="left: 110.22rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-1AN11-2" node-style="left: 112.08rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-1AN11-3" node-style="left: 113.95rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN11-4" node-style="left: 115.8rem;top: 17.4rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN11-5" node-style="left: 3.74rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN11-6" node-style="left: 5.67rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN11-7" node-style="left: 7.64rem;top: 30.28rem;"></SignalNode>

        <SignalNode :context="context" info="室外活动预留配电箱" node-title="D3-1AN10-1" node-style="left: 9.6rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="厨房（主用）" node-title="D3-1AN10-2" node-style="left: 11.5rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-1AN10-3" node-style="left: 13.47rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="安全照明（主用）" node-title="D3-1AN10-4" node-style="left: 15.41rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-1AN10-5" node-style="left: 17.35rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-1AN10-6" node-style="left: 19.3rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN10-7" node-style="left: 21.29rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN10-8" node-style="left: 23.22rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN10-9" node-style="left: 25.2rem;top: 30.28rem;"></SignalNode>

        <SignalNode :context="context" info="照明总箱1" node-title="D3-1AN9-1" node-style="left: 27.15rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="走道照明" node-title="D3-1AN9-2" node-style="left: 29.1rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="走道照明" node-title="D3-1AN9-3" node-style="left: 31rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="厨房（主用）" node-title="D3-1AN9-4" node-style="left: 32.97rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="空调" node-title="D3-1AN9-5" node-style="left: 34.91rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-1AN9-6" node-style="left: 36.85rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="热水机房" node-title="D3-1AN9-7" node-style="left: 38.79rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN9-8" node-style="left: 40.75rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN9-9" node-style="left: 42.7rem;top: 30.28rem;"></SignalNode>

        <SignalNode :context="context" info="避难走廊用电" node-title="D3-1AN8-1" node-style="left: 46.6rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="运营商（主用）" node-title="D3-1AN8-2" node-style="left: 48.54rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="弱电间电源总箱（主用）" node-title="D3-1AN8-3" node-style="left: 50.48rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="站用电（主用）" node-title="D3-1AN8-4" node-style="left: 52.41rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="普通排水泵总箱（备用）" node-title="D3-1AN8-5" node-style="left: 54.41rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN8-6" node-style="left: 56.3rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN8-7" node-style="left: 58.29rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN8-8" node-style="left: 60.25rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN8-9" node-style="left: 62.2rem;top: 30.28rem;"></SignalNode>

        <SignalNode :context="context" info="空调风机总箱" node-title="D3-1AN7-1" node-style="left: 64.15rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="电梯" node-title="D3-1AN7-2" node-style="left: 66.09rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="照明" node-title="D3-1AN7-3" node-style="left: 68.0rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="配套产业" node-title="D3-1AN7-4" node-style="left: 69.96rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="羽毛球球场安全照明（主用）" node-title="D3-1AN7-5" node-style="left: 71.91rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明" node-title="D3-1AN7-6" node-style="left: 73.86rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN7-7" node-style="left: 75.8rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN7-8" node-style="left: 77.78rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN7-9" node-style="left: 79.7rem;top: 30.28rem;"></SignalNode>

        <SignalNode :context="context" info="泛光照明配电箱" node-title="D3-1AN6-1" node-style="left: 81.66rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="功放设备（备用）" node-title="D3-1AN6-2" node-style="left: 83.59rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="环屏用电" node-title="D3-1AN6-3" node-style="left: 85.54rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（备用）" node-title="D3-1AN6-4" node-style="left: 87.53rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（主用）" node-title="D3-1AN6-5" node-style="left: 89.47rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="安全照明（主用）" node-title="D3-1AN6-6" node-style="left: 91.41rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（备用）" node-title="D3-1AN6-7" node-style="left: 93.35rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="HES交流屏电源（主用）" node-title="D3-1AN6-8" node-style="left: 95.3rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="检修电源箱" node-title="D3-1AN6-9" node-style="left: 97.27rem;top: 30.28rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-1AN6-10" node-style="left: 99.21rem;top: 30.28rem;"></SignalNode>

        <SignalNode :context="context" info="母联柜" node-title="D3-1AN5" node-style="left: 103.1rem;top: 30.46rem;"></SignalNode>

        <SignalNode :context="context" info="有源滤波装置" node-title="D3-1AN4" node-style="left: 106.6rem;top: 30.46rem;"></SignalNode>

        <SignalNode :context="context" info="动态自动无功补偿" node-title="D3-1AN3" node-style="left: 109.75rem;top: 30.46rem;"></SignalNode>

        <SignalNode :context="context" info="动态自动无功补偿" node-title="D3-1AN2" node-style="left: 113.2rem;top: 30.46rem;"></SignalNode>

        <SignalNode :context="context" info="3-#1变压器进线柜" node-title="D3-1AN1" node-style="left: 115.84rem;top: 30.55rem;"></SignalNode>


        <SignalNode :context="context" info="3-#2变压器进线柜" node-title="D3-2AN1" node-style="left: 3.66rem;top: 42.15rem;"></SignalNode>
        <SignalNode :context="context" info="动态自动无功补偿" node-title="D3-2AN2" node-style="left: 6.79rem;top: 42.15rem;"></SignalNode>
        <SignalNode :context="context" info="动态自动无功补偿" node-title="D3-2AN3" node-style="left: 9.86rem;top: 42.15rem;"></SignalNode>
        <SignalNode :context="context" info="有源滤波装置" node-title="D3-2AN4" node-style="left: 13.66rem;top: 42.15rem;"></SignalNode>

        <SignalNode :context="context" info="安全照明（备用）" node-title="D3-2AN5-1" node-style="left: 17.16rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="照明总箱" node-title="D3-2AN5-2" node-style="left: 19.08rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="照明总箱" node-title="D3-2AN5-3" node-style="left: 20.95rem; top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="空调风机总箱" node-title="D3-2AN5-4" node-style="left: 22.91rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="羽毛球球场安全照明（备用）" node-title="D3-2AN5-5" node-style="left: 24.85rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="配套产业" node-title="D3-2AN5-6" node-style="left: 26.76rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="草坪补光系统" node-title="D3-2AN5-7" node-style="left: 28.66rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN5-8" node-style="left: 30.56rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN5-9" node-style="left: 32.52rem;top: 41.85rem;"></SignalNode>

        <SignalNode :context="context" info="走廊照明" node-title="D3-2AN6-1" node-style="left: 36.3rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-2AN6-2" node-style="left: 38.277rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-2AN6-3" node-style="left: 40.16rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="厨房（备用）" node-title="D3-2AN6-4" node-style="left: 42.14rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="安全照明（备用）" node-title="D3-2AN6-5" node-style="left: 44.0rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="普通照明" node-title="D3-2AN6-6" node-style="left: 45.94rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="HE$交流屏电源（备用）" node-title="D3-2AN6-7" node-style="left: 47.85rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN6-8" node-style="left: 49.75rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN6-9" node-style="left: 51.66rem;top: 41.85rem;"></SignalNode>

        <SignalNode :context="context" info="照明总箱1" node-title="D3-2AN7-1" node-style="left: 55.5rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-2AN7-2" node-style="left: 57.43rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="弱电间电源总箱（备用）" node-title="D3-2AN7-3" node-style="left: 59.35rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="站用电（主用）" node-title="D3-2AN7-4" node-style="left: 61.26rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="运营商（主用）" node-title="D3-2AN7-5" node-style="left: 63.2rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN7-6" node-style="left: 65.15rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN7-7" node-style="left: 67.02rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN7-8" node-style="left: 68.96rem;top: 41.85rem;"></SignalNode>

        <SignalNode :context="context" info="厨房" node-title="D3-2AN8-1" node-style="left: 72.8rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="走道照明" node-title="D3-2AN8-2" node-style="left: 74.7rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="厨房（备用）" node-title="D3-2AN8-3" node-style="left: 76.64rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="厨房（主用）" node-title="D3-2AN8-4" node-style="left: 78.54rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="厨房（备用）" node-title="D3-2AN8-5" node-style="left: 80.47rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="普通风机总箱" node-title="D3-2AN8-6" node-style="left: 82.41rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN8-7" node-style="left: 84.295rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN8-8" node-style="left: 86.22rem;top: 41.85rem;"></SignalNode>

        <SignalNode :context="context" info="潜污泵" node-title="D3-2AN9-1" node-style="left: 90.04rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="扶梯" node-title="D3-2AN9-2" node-style="left: 92.0rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="厨房" node-title="D3-2AN9-3" node-style="left: 93.9rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-2AN9-4" node-style="left: 95.8rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="LED屏幕" node-title="D3-2AN9-5" node-style="left: 97.72rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN9-6" node-style="left: 99.65rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN9-7" node-style="left: 101.58rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN9-8" node-style="left: 103.49rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN9-9" node-style="left: 105.41rem;top: 41.85rem;"></SignalNode>

        <SignalNode :context="context" info="普通排水泵总箱（主用）" node-title="D3-2AN10-1" node-style="left: 109.22rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-2AN10-2" node-style="left: 111.16rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="普通用电" node-title="D3-2AN10-3" node-style="left: 113.1rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="室外景观总箱" node-title="D3-2AN10-4" node-style="left: 115.0rem;top: 41.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN10-5" node-style="left: 3.66rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="空调" node-title="D3-2AN10-6" node-style="left: 5.76rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN10-7" node-style="left: 7.8rem;top: 52.97rem;"></SignalNode>



        <SignalNode :context="context" info="商业" node-title="D3-2AN11-1" node-style="left: 9.91rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-2AN11-2" node-style="left: 11.97rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D3-2AN11-3" node-style="left: 14.04rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="热交换机房" node-title="D3-2AN11-4" node-style="left: 16.16rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN11-5" node-style="left: 18.2rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN11-6" node-style="left: 20.29rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN11-7" node-style="left: 22.35rem;top: 52.97rem;"></SignalNode>

        <SignalNode :context="context" info="普通风机" node-title="D3-2AN12-1" node-style="left: 24.41rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="避难走道用电" node-title="D3-2AN12-2" node-style="left: 26.54rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="空调" node-title="D3-2AN12-3" node-style="left: 28.59rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="室外活动预留配电箱" node-title="D3-2AN12-4" node-style="left: 30.66rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN12-5" node-style="left: 32.7rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN12-6" node-style="left: 34.8rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN12-7" node-style="left: 36.9rem;top: 52.97rem;"></SignalNode>

        <SignalNode :context="context" info="消防电源总箱（备用）" node-title="D3-2AN13-1" node-style="left: 38.95rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-2AN13-2" node-style="left: 41.05rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-2AN13-3" node-style="left: 43.1rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-2AN13-4" node-style="left: 45.2rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-2AN13-5" node-style="left: 47.25rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-2AN13-6" node-style="left: 49.33rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-2AN13-7" node-style="left: 51.45rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-2AN13-8" node-style="left: 53.5rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN13-9" node-style="left: 55.55rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN13-10" node-style="left: 57.65rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN13-11" node-style="left: 59.7rem;top: 52.97rem;"></SignalNode>


        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-2AN14-1" node-style="left: 61.8rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-2AN14-2" node-style="left: 63.9rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-2AN14-3" node-style="left: 65.95rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-2AN14-4" node-style="left: 68.02rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D3-2AN14-5" node-style="left: 70.1rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D3-2AN14-6" node-style="left: 72.2rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源（主用）" node-title="D3-2AN14-7" node-style="left: 74.25rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="排烟风机（备用）" node-title="D3-2AN14-8" node-style="left: 76.35rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN14-9" node-style="left: 78.41rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN14-10" node-style="left: 80.48rem;top: 52.97rem;"></SignalNode>

        <SignalNode :context="context" info="功放设备（主用）" node-title="D3-2AN16-1" node-style="left: 90.85rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（主用）" node-title="D3-2AN16-2" node-style="left: 92.95rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（备用）" node-title="D3-2AN16-3" node-style="left: 95.0rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（主用）" node-title="D3-2AN16-4" node-style="left: 97.1rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（备用）" node-title="D3-2AN16-5" node-style="left: 99.16rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN16-6" node-style="left: 101.27rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN16-7" node-style="left: 103.34rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN16-8" node-style="left: 105.4rem;top: 52.97rem;"></SignalNode>

        <SignalNode :context="context" info="备用" node-title="D3-2AN17-1" node-style="left: 107.47rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN17-2" node-style="left: 109.55rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN17-3" node-style="left: 111.65rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN17-4" node-style="left: 113.73rem;top: 52.97rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D3-2AN17-5" node-style="left: 115.78rem;top: 52.97rem;"></SignalNode>


      </div>
    </div>
  </div>
</template>

<script setup>

import {useSize} from "@/assets/js/size";
import SignalNode from "@/components/system/SignalNode";
import {ref} from "vue";
import {useRealTimeDataService} from "@/assets/js/realTimeDataService";
import {useSensorCompute} from "@/assets/js/sensorCompute";
import useUtils from "@/assets/js/utils";
const {height} = useSize();
let context = ref({})
const {alert} = useUtils();

function service(data){
  for (let key in data){
    context.value[key] = data[key];
    if (data[key]?.alert){
      alert.value['es3'] = true;
    }
  }
  context.value['alert'] = alert.value['es3'];
}
useRealTimeDataService(service, 3,{checkFR: true});
let sensorCompute = useSensorCompute(context);
</script>

<style scoped>
.diagram{
  position: relative;
  margin: 70px auto 0;
}
@media screen and (min-width: 3840px) {
  .diagram,.bg-diagram{
    width: 3840px;
  }
}
@media screen and (max-width: 3840px) {
  .diagram,.bg-diagram{
    width: 3840px;
  }
}

@media screen and (max-width: 3000px){
  .diagram,.bg-diagram{
    width: 3000px;
  }
}

@media screen and (max-width: 1920px){
  .diagram,.bg-diagram{
    width: 1920px;
  }
}

.diagram,.bg-diagram{
  width: 1920px;
}

.main-table{
  width: 9.5rem;
  height: 6.45rem;

  float:left;
  border:1px solid #666;
  text-align: center;
  color: white;
  line-height: 1.5625rem;
  font-size: 0.8125rem;
}
.main-table-row{
  width: 100%;
  height: 1.5625rem;
  line-height: 1.5625rem;
  font-size: 0.8125rem;
  border-bottom: 1px dashed grey;
  display: flex;
  flex-wrap: nowrap;
}
.main-table-row:last-child{
  border-bottom: none;
}
.main-table-cell{
  flex:0 50px;
}
.main-table-cell:nth-child(1){
  border-right: 1px dashed grey;
}
.main-table-cell:nth-child(2){
  flex:1 0px;
  font-weight: bold;
  font-size: 0.9375rem;
}
.main-table-cell:nth-child(3){
  border-left: 1px dashed grey;
  flex:0 30px;
}

.IA{
  color: #dede12
}
.IB{
  color:#0dd22d
}
.P{
  color: #00ceff;
}
.Q{
  color: #ec4cff;
}
.COS{
  color: #0d86ed ;
}
</style>